import classNames from 'classnames';

interface ColumnsProps {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
}

const Columns: React.FC<ColumnsProps> = ({ children, className }) => (
  <div className={classNames('zb-columns', className)}>{children}</div>
);

export default Columns;
